export default __webpack_public_path__ + "static/banklessacademy-f6e38855aab7b20e7a00cd4cd3985dde.jpg";